import { createSlice } from '@reduxjs/toolkit'
import { magicaSpellGameCashOut, magicaSpellGamePlacedBet, magicaSpellGamePreviousRoundState, magicaSpellKickCount } from './penaltyShootoutGame.thunk'
import { BET_RESULT } from 'utils/constants/index'

const initialState = {
  loading: false,
  currentRound: 0,
  currentPlacedBet: null,
  betLock: false,
  gameEnd: false,
  isLastWin: false,
  isLastLoss: false
}

const {
  actions: {
    penaltyGameRoundEnd
  },
  reducer
} = createSlice({
  name: 'magicaSpellGame',
  initialState,
  reducers: {
    penaltyGameRoundEnd: (state, action) => {
      return {
        ...state,
        betLock: false,
        gameEnd: false,
        currentRound: 0,
        currentPlacedBet: initialState.currentPlacedBet
      }
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(magicaSpellGamePreviousRoundState.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(magicaSpellGamePreviousRoundState.fulfilled, (state, action) => {
        if (action.payload?.hasUnfinishedGame) {
          const currentRound = action.payload?.unfinishedGameBetDetails?.currentRound
          return {
            ...state,
            loading: false,
            currentRound,
            currentPlacedBet: action?.payload?.unfinishedGameBetDetails,
            betLock: true
          }
        }

        return {
          ...state,
          loading: false
        }
      })

      .addCase(magicaSpellGamePlacedBet.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(magicaSpellGamePlacedBet.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          currentPlacedBet: action.payload,
          betLock: true
        }
      })
      .addCase(magicaSpellGamePlacedBet.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(magicaSpellGameCashOut.pending, (state, action) => {
        return {
          ...state,
          gameEnd: false,
          loading: true
        }
      })
      .addCase(magicaSpellGameCashOut.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          currentPlacedBet: action.payload,
          gameEnd: true
        }
      })
      .addCase(magicaSpellGameCashOut.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(magicaSpellGamePreviousRoundState.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(magicaSpellKickCount.pending, (state) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(magicaSpellKickCount.fulfilled, (state, action) => {
        if (action.payload?.result === BET_RESULT.LOST || action.payload?.result === BET_RESULT.WON) {
          const currentRound = action.payload?.result === BET_RESULT.LOST ? state.currentRound : action.payload?.currentRound
          return {
            ...state,
            currentRound,
            gameEnd: true,
            loading: false,
            currentPlacedBet: action.payload
          }
        } else {
          return {
            ...state,
            loading: false,
            currentRound: action.payload?.currentRound
          }
        }
      })
      .addCase(magicaSpellKickCount.rejected, (state) => {
        return {
          ...state,
          loading: false
        }
      })
  }
})

export default reducer

export { penaltyGameRoundEnd }
